import React from "react";
import { Drawer, Space } from "antd";

export default function SubscriptionDrawerShell({
  open,
  title,
  width,
  zIndex = 1600,
  onClose,
  footer,
  bodyStyle,
  children,
}) {
  return (
    <Drawer
      open={open}
      title={title}
      onClose={onClose}
      width={width}
      zIndex={zIndex}
      destroyOnClose
      styles={{ body: { paddingBottom: 96, ...bodyStyle } }}
      footer={
        footer ? (
          <Space style={{ width: "100%", justifyContent: "flex-end" }}>{footer}</Space>
        ) : null
      }
    >
      {children}
    </Drawer>
  );
}
